import { render, staticRenderFns } from "./CbsUserMenuItem.vue?vue&type=template&id=10148196&scoped=true"
import script from "./CbsUserMenuItem.vue?vue&type=script&lang=js"
export * from "./CbsUserMenuItem.vue?vue&type=script&lang=js"
import style0 from "./CbsUserMenuItem.vue?vue&type=style&index=0&id=10148196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10148196",
  null
  
)

export default component.exports